
import { SiriusBaseComponent } from 'sirius-framework';
import { Component, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { IndividualSalesService } from '../../../inner-menu-sales/inner-menu-sales.service';
import { ValidationService } from '../../../shared/service/validation-service';

import { SalesTransactionInformationModel } from '../../../shared/models/salesinformation.model';
import { MemberInfo } from '../../../shared/models/shared.model';
import { MessageShowComponent } from '../../../popup/message-show/message-show.component';
import { CommonService } from '../../../shared/service/shared.service';
import { SharedModel } from '../../../shared/models/shared.model';
import { TransactionNames } from '../../../shared/constants/constants'

declare const $: any;

@Component({
    selector: 'sales-corporate',
    templateUrl: './sales-corporate.component.html',
    styleUrls: ['./sales-corporate.component.css']
})
export class SalesCorporateComponent extends SiriusBaseComponent<any> implements AfterViewInit {
    @ViewChild('SellerIban') sellerIban: any;
    @ViewChild('SellerEmail') sellerEmail: any;
    @ViewChild('SellerName') sellerName: any;
    @ViewChild('SellerMernisNo') sellerMernisNo: any;
    @ViewChild('Plate') plate: any;
    @ViewChild('SalesAmount') salesAmount: any;
    @ViewChild('BuyerPhone') buyerPhone: ElementRef;
    @ViewChild('messagePopup') messagePopup: MessageShowComponent;

    salesTransactionInformationItem: SalesTransactionInformationModel = new SalesTransactionInformationModel();

    mernisNo: string;
    pageNumber = 0;
    profileEmail: string;
    profileNameSurname: string;
    salesInformationReceived = false;
    isIbanValid = false;
    isVKNValid = true;
    isPlateValid = true;
    sellerNameIsValid = true;
    isAmountValid = true;

    sellerMernisNoErrorMessage: string;
    sellerNameErrorMessage: string;
    sellerIbanErrorMessage: string;
    amountError: string;

    isBuyerPhoneNotValid = false;

    phoneValidation: string;
    referenceNumber = "0";
    referenceNumberGoi = "0";
    bankName: string;
    formattedIban: string;
    totalAmountDec: number;
    totalAmount: string;
    commissionAmount = 0;
    amountMinThanCommissionError: string;
    licencePlateError: string;
    plateErrorResource: string;
    branchArray: any[]; 
    private popUpMessage: string;
    sellerIbanMessage: string;

    showBackToMainButton = false;
    emailNotValid = false;

    errorMessage: string;
    confirmMessageFilled: string;
    confirmMessage: string;
    confirmMessageComm: string;
    resultMessage: string;
    gktiMessage: string;
    confirmMessageExtra: string;
    confirmMessageExtraForIban: string = 'İşleme devam edebilirsiniz, ancak dikkat etmeniz gereken bir durum tespit edildi. Girilen (VKN) Vergi Kimlik Numarasına ait ünvan, IBAN doğrulama süreci sonucunda elde edilen ünvanla tam olarak eşleşmemektedir. Bu durum, tescil sonrası yapılacak transfer işleminde gecikmeye veya aksaklığa neden olabilir. Bilgilerinizi lütfen tekrar gözden geçirerek doğru IBAN girdiğinizden emin olunuz. Gerekirse, Geri butonuna basarak önceki adıma dönerek bilgileri güncelleyebilirsiniz.';
    showConfirmMessageExtraForIban: boolean =false
    titleDisabled = false;

    regexPlate = /^(0[1-9]|[1-7][0-9]|8[01])((\s?[a-zA-Z]\s?)(\d{4,5})|(\s?[a-zA-Z]{2}\s?)(\d{3,4})|(\s?[a-zA-Z]{3}\s?)(\d{2,4}))$/;
    maskTel = ['(', /[5]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];

    private profileInfo: MemberInfo = new MemberInfo(); 

    constructor(private apiService: IndividualSalesService, private validateService: ValidationService,
        private commonService: CommonService) {
        super();
    }

    OnInit() { 
        this.apiService.dataServiceInstance = this.dataService;
        this.validateService.dataServiceInstance = this.dataService;
        this.branchArray = this.commonService.publicEftList.BranchArray;

        let response = this.apiService.getCustomerInfo().toPromise();
        response.then((result) => {
            this.profileInfo = <MemberInfo>result;
          this.profileEmail = this.profileInfo ? this.profileInfo.Email : "";
          this.profileNameSurname = this.profileInfo ? this.profileInfo.Name + " "+this.profileInfo.Surname : "";
            this.sellerEmail.isDisabled = !(this.profileInfo.Email != null && this.profileInfo.Email != "");
        });

        this.confirmMessage = this.resourceService.getResource("salesCorp_ConfirmMessage");
        this.confirmMessageComm = this.resourceService.getResource("salesCorp_ConfirmMessageComm");
        this.resultMessage = this.resourceService.getResource("sales_ResultMessage");
        this.plateErrorResource = this.resourceService.getResource("sales_LicencePlateError");
        this.amountMinThanCommissionError = this.resourceService.getResource("sales_AmountMinThanCommissionError");
        this.errorMessage = this.resourceService.getResource("sales_ErrorMessage"); 
        this.sellerIbanMessage = this.resourceService.getResource("SellerIbanMessage");
        this.confirmMessageExtra = this.resourceService.getResource("sales_confirmMessageExtra");
        this.gktiMessage = this.resourceService.getResource("sales_gktiMessage");
      if (this.confirmMessageExtra == 'generalresource_tr-tr_sales_confirmmessageextra' || this.confirmMessageExtra == '0')
            this.confirmMessageExtra = '';
    }

    private formValidation(): void {
        if (this.pageNumber === 1) {
            if (this.sellerIban && this.sellerIban.value == null && !this.isIbanValid) {
                this.sellerIban.errorMessage = "IBAN bilgisi zorunludur.";
            }
        }

    }

    private formValidationForEmptyFields(): boolean {
        let result = true;

      
      if (this.sellerMernisNo && (this.sellerMernisNo.value === undefined || this.sellerMernisNo.value === null || this.sellerMernisNo.value === '')) {
        this.isVKNValid = false; 
        result = false;
      }
      else {
        this.mernisNo = this.sellerMernisNo.value.replace(/\s/g, '');
        this.sellerMernisNo.value = this.mernisNo;
        if (this.mernisNo === null || this.mernisNo === '') {
          this.isVKNValid = false;
        }
        else if (this.mernisNo.length !== 10) {
          this.isVKNValid = false;
          this.sellerMernisNoErrorMessage = "Geçerli bir vergi kimlik numarası giriniz.";
          result = false;
        }
      }
      if (result === false)
        this.sellerMernisNoErrorMessage = "Vergi Kimlik Numarası zorunludur.";
      else
        this.sellerMernisNoErrorMessage = "";


    

        if (this.sellerName && (this.sellerName.value == undefined || this.sellerName.value == null || this.sellerName.value == '')) {
            this.sellerNameIsValid = false;
            this.sellerNameErrorMessage = "Ünvan bilgisi zorunludur.";
            result = false;
        }

        if (this.sellerIban && (this.sellerIban.value == undefined || this.sellerIban.value == null || this.sellerIban.value == '')) {
          this.isIbanValid = false;
            this.sellerIbanErrorMessage = "IBAN bilgisi zorunludur.";
            result = false;
        }
        else if ( this.sellerIban.value.length != 24) {
            this.isIbanValid = false;
            this.sellerIbanErrorMessage = "Geçersiz IBAN";
            result = false;
        }
        return result;
  }

  private amountValid(event: any): void {
    if (this.salesAmount && (this.salesAmount.value == undefined || this.salesAmount.value == null || this.salesAmount.value == '')) {
      this.isAmountValid = false;
      this.amountError = "Ödenecek tutar bilgisi zorunludur.";
    }
    else {
      this.isAmountValid = true;
      this.amountError = "";
    }
  }

    private controlEmail(event: any): void {

        if (this.profileEmail == null || this.profileEmail == '') {
            this.emailNotValid = false;
            return;
        }

        if (!this.profileEmail.includes('@') || !this.profileEmail.includes('.')) {
            this.emailNotValid = true;
            return;
        }

        this.emailNotValid = false;
        let promise = this.validateService.validateMail(this.profileEmail).toPromise();
        promise.then((serviceResult) => {
            if (serviceResult.IsValid == false) {
                this.emailNotValid = true;
            }
        });
  }

  private plateValid(event: any): void {
    if (this.plate && (this.plate.value == undefined || this.plate.value == null || this.plate.value == '')) {
      this.isPlateValid = false;
      this.licencePlateError = "Plaka bilgisi zorunludur.";
    }
    else {
      this.isPlateValid = true;
      this.licencePlateError = "";
    }
  }


    private formValidationForEmptyFieldsII(): boolean {
        let result = true;

      if (this.plate && (this.plate.value == undefined || this.plate.value == null || this.plate.value == '')) {
        this.isPlateValid = false;
        this.licencePlateError = this.plateErrorResource;
            result = false;
        }
        if (this.salesAmount && (this.salesAmount.value == undefined || this.salesAmount.value == null || this.salesAmount.value == '')) {
            this.isAmountValid = false;
            this.amountError = "Ödenecek tutar bilgisi zorunludur.";
            result = false;
        }

        if (this.buyerPhone && (this.buyerPhone.nativeElement.value == undefined || this.buyerPhone.nativeElement.value == null || this.buyerPhone.nativeElement.value == '')) {
            this.isBuyerPhoneNotValid = true;
            this.phoneValidation = "Telefon bilgisi zorunludur.";
            result = false;
        }
        return result;
    }

    ngAfterViewInit() { 
        this.formValidation();
    }

    showPanel(pageIndex: number) {
        $("kendo-maskedtextbox").addClass("form-control");
        $("kendo-numerictextbox").addClass("form-control");
        $("input#SellerEmail.sirius-textbox").addClass("email");
        //$("kendo-numerictextbox").css("font", "400 13.3333px Arial");
        //$("kendo-maskedtextbox").css("font", "400 13.3333px Arial");
        $("kendo-numerictextbox").css("font-size", "16px");
        $("kendo-maskedtextbox input").css("font-size", "16px"); 

        if (pageIndex === -1 && this.pageNumber !== 3) //footer
            return true;
        return pageIndex == this.pageNumber
    }

    confirmCheckboxChange(e: any) {
        if(e.target.checked)
            this.messagePopup.showPopup();
    }

    onMessageAccepted() {
    
    }
    private ibanValid(event: any): void {
        this.isIbanValid = true;
      let promise = this.validateService.validateIBANCorp(this.salesTransactionInformationItem.SellerIban, this.salesTransactionInformationItem.SellerMernisNo).toPromise();
        promise.then((result) => {
            let rtnVal = <any>result;
            if (!rtnVal.IsValid ) {
              this.isIbanValid = false;
                this.sellerIbanErrorMessage = result.ResultMessage;
                if (result.ForceLogOut)
                    this.commonService.logOutClient();
            }
            else {
              this.isIbanValid = true;
              if (result.ResultMessage != 'OK')
                this.showConfirmMessageExtraForIban = true;
              else
                this.showConfirmMessageExtraForIban = false;
              if (event != null && event.relatedTarget!=null && event.relatedTarget.name!=null &&   event.relatedTarget.name == "Next") {
                    this.pageNumber++;
                }
            }
        });
  }

  private sellerNameValid(event: any): void{

    if (this.sellerName && (this.sellerName.value === undefined || this.sellerName.value === null || this.sellerName.value === '')) {
      this.sellerNameIsValid = false;
      this.sellerNameErrorMessage = "Ünvan bilgisi zorunludur.";
    } 
  }

    private vknValid(event: any): void {
        this.isVKNValid = true;
        let promise = this.validateService.validateVKN(this.salesTransactionInformationItem.SellerMernisNo).toPromise();
       
        promise.then((result) => {
            let rtnVal = <any>result;
            if (!rtnVal.IsValid) {
              this.isVKNValid = false;
              if (result.ResultMessage == 'VKNGKTI') {
                this.messagePopup.showCancelButton = false;
                this.popUpMessage = 'Şahıs şirketine ait satış kaydı bireysel satış seçeneğinden girilmelidir.';
                this.sellerMernisNoErrorMessage = 'Ruhsatta T.C./Yabancı/Mavi Kart kimlik no yazıyorsa bireysel satış girilmelidir.';
                this.messagePopup.showPopup();
              }
              else {
                this.sellerMernisNoErrorMessage = result.ResultMessage;
                this.salesTransactionInformationItem.SellerName = '';
                this.titleDisabled = false;
              }
                if (result.ForceLogOut)
                    this.commonService.logOutClient();
            }
            else { 
                  this.isVKNValid = true; 
                this.salesTransactionInformationItem.SellerName = result.Title;
                this.sellerMernisNoErrorMessage = result.ResultMessage;
                if (result.Title == '')
                  this.titleDisabled = false;
                else {
                  this.titleDisabled = true;
                  this.sellerNameIsValid = true;
                  this.sellerNameErrorMessage = "";
              }
            }
        });
    }

    private getCalculateStpCommission() {
        return this.apiService.getStpCommission(this.salesTransactionInformationItem.SalesAmount);
    }

    private verifyIBAN() { 
        return this.validateService.verifyIBAN(this.salesTransactionInformationItem.SellerIban,
            this.salesTransactionInformationItem.SellerName, 
            'T');
    }

    private createStpSeller() {
        return this.apiService.createStpSellerTransaction(this.salesTransactionInformationItem);
    }

    private updateEmail() {
        return this.apiService.updateCustomerInfo(this.profileInfo);
    }

    private getBankList() {
        return this.validateService.getEftBankList();
    }

    nextFunction() {
        if (this.pageNumber === 0) {
            if (!this.formValidationForEmptyFields()) {
                return;
            }
          this.ibanValid(this);
          this.vknValid(this);

            if (this.emailNotValid || (this.sellerEmail.errors && (this.sellerEmail.touched || this.sellerEmail.dirty))) {
                return;
            }

          if (/*this.sellerMernisNo.isValid*/ this.isVKNValid && this.isIbanValid) {

                var sellermernis = this.salesTransactionInformationItem.SellerMernisNo.replace(/\s/g, '');
                this.salesTransactionInformationItem.SellerMernisNo = sellermernis;
                let bankCode = this.salesTransactionInformationItem.SellerIban.substring(3, 7);
                this.formattedIban = 'TR' + this.salesTransactionInformationItem.SellerIban.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();


                let bankList = this.getBankList().toPromise().then((result) => {
                    let branch = result.BranchArray.filter(c =>
                        c.BankCode == bankCode)[0];

                    this.bankName = branch.BankFriendlyName; 
                });

                if ((this.profileInfo.Email == "" || this.profileInfo.Email == null || this.profileInfo.Email == undefined) && this.sellerEmail && this.sellerEmail.value != null &&  this.sellerEmail.value != '') {
                        this.emailNotValid = false;
                        this.profileInfo.Email = this.sellerEmail.value;
                        this.profileInfo.UpdatedFieldInfo = "E";
                        this.updateEmail().toPromise().then((result) => { 
                        });
                        this.pageNumber++;
                }
                else {
                    this.pageNumber++;

                }
            }
        }
        else if (this.pageNumber === 1) {
            if (!this.formValidationForEmptyFieldsII()) {
                return;
            }

          if (this.isAmountValid && this.isPlateValid) {
                this.totalAmount = this.salesAmount.value.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })+ " TL";
                let bankCode = this.salesTransactionInformationItem.SellerIban.substring(3, 7);
                this.formattedIban = 'TR' + this.salesTransactionInformationItem.SellerIban.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();

            if (this.branchArray != null) {
              let branch = this.branchArray.filter(c =>  c.BankCode == bankCode)[0];

              this.bankName = branch ? branch.BankFriendlyName : "";
            }

                //2 - TELEFON NO VALİDASYONU //
                if (this.salesTransactionInformationItem.BuyerPhone.replace(/"/g, "").replace(/'/g, "").replace(/\(|\)/g, "").replace(/-/g, "").replace(/\s/g, '') ==
                    this.profileInfo.PhoneNumber.replace(/"/g, "").replace(/'/g, "").replace(/\(|\)/g, "").replace(/-/g, "").replace(/\s/g, '')) {

                    this.isBuyerPhoneNotValid = true;
                    this.phoneValidation = "Satıcı telefonu girilemez.";
                }
                else if (this.salesTransactionInformationItem.BuyerPhone.replace(/_/g, "").replace(/\s/g, '').length != 14) {
                    this.isBuyerPhoneNotValid = true;
                    this.phoneValidation = "Telefon bilgisi zorunludur.";
                }
            

                 // 4- TUTAR VALİDASYONU /
                /////////////////////////////////////////////////////
                this.confirmMessageFilled = '';
                this.totalAmountDec = this.salesTransactionInformationItem.SalesAmount;

                let promise = this.getCalculateStpCommission().toPromise();
            promise.then((result) => {

               //////////////PhoneValidation//////////
              this.isBuyerPhoneNotValid = false;
              let promise = this.validateService.validatePhonenumber(this.salesTransactionInformationItem.BuyerPhone).toPromise();
              promise.then((result) => {
                this.phoneValidation = "Cep telefonu numarası geçersiz.";
                this.isBuyerPhoneNotValid = !result.IsValid;
              });
               //////////////PhoneValidation//////////

                    this.commissionAmount = result.CommissionAmount;

                    if (this.totalAmountDec <= this.commissionAmount) {
                        this.isAmountValid = false;
                        this.amountError = this.amountMinThanCommissionError;

                    }
                    else {
                      this.isAmountValid = true;
                      this.amountError = '';

                        if (!this.isBuyerPhoneNotValid && this.isPlateValid) {
                            ////////////CONFIRM MESSAGE///////////////////////////////////
                            if (this.commissionAmount == 0) {
                                this.confirmMessageFilled = this.commonService.prepareStringText(this.confirmMessageComm,
                                    [{ key: 'formattedIban', value: this.formattedIban.bold() },
                                    { key: 'bankName', value: this.bankName.bold() },
                                    { key: 'totalAmount', value: this.totalAmount.bold() }]);
                            }
                            else {
                                this.confirmMessageFilled = this.commonService.prepareStringText(this.confirmMessage,
                                    [{ key: 'formattedIban', value: this.formattedIban.bold() },
                                    { key: 'bankName', value: this.bankName.bold() },
                                    { key: 'totalAmount', value: this.totalAmount.bold() },
                                    { key: 'commissionAmount', value: (this.commissionAmount.toLocaleString('tr-TR', { style: 'decimal' }) + " TL").bold() }]);
                            }

                            this.pageNumber++;
                        }
                    }
                });

            }
        }
        else {
            this.pageNumber++;
        }
    }

    backFunction() {
        this.pageNumber--;
    }

    submitFunction() {  
        this.salesTransactionInformationItem.CustomerType = "T";
          
        this.createStpSeller().toPromise().then((result) => { 
            this.showBackToMainButton = true;
          this.referenceNumber = result.ResultID;
          this.referenceNumberGoi = result.ResultIDGoi;
            this.pageNumber++;
            this.errorMessage = result.ResultMessage;
            if (result.ResultCode == 10) { 
                setTimeout(() => {
                    this.commonService.logOutClient();
                }, 10000);
            }
        });
    }

    cancelFunction() {
        this.commonService.StartTransaction(TransactionNames.InnerMenuTransaction, SharedModel.PageName_MainInnerPage);
    }

    onCopy() {
        var dummy = document.createElement("textarea");
        document.body.appendChild(dummy);
        dummy.value = this.referenceNumber;
        dummy.select();
        document.execCommand("copy");
        document.body.removeChild(dummy);

    }

    showIbanInfo(e: any) {
        this.messagePopup.showCancelButton = false;
        this.popUpMessage = this.sellerIbanMessage;
        this.messagePopup.showPopup();
        e.preventDefault();
  }

  showAmountInfo(e: any) {
    this.messagePopup.showCancelButton = false;
    this.popUpMessage = 'QNB Güvenli Ödeme Sistemi ile sadece araç satış bedelinin nakit ödenecek kısmı ile işlem yapılabilir. Hesabınıza transfer edilmesini beklediğiniz tutarı giriniz.';
    this.messagePopup.showPopup();
    e.preventDefault();
  }

  phoneMaskValid(e: any) {
    if (this.buyerPhone.nativeElement.classList.contains('ng-valid')) {
      this.isBuyerPhoneNotValid = false;
    }
    else {
      this.isBuyerPhoneNotValid = true;
      this.phoneValidation = "Alıcı telefonu bilgisi zorunludur.";
    }
  }
   
}
